import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard_screen.css";
import YakapLogo from "../../Assets/Images/yakap_logo.avif";
import { useNavigate } from "react-router-dom";

//API calls
import { fetchNewPatients } from "../../Helpers/ApiCalls/Dashboard/DashboardApi";

import SidebarMenu from "../../Components/Sidebar/Sidebar";

import { getName, getRole } from "../../Components/Helpers/Utilities/Common.js";
import { formatDateWithTime } from "../../Helpers/Utils/Common.js";

function Dashboard() {
  const role = getRole();
  const [timeOfDay, setTimeOfDay] = useState(getTimeOfDay());
  const [data, setData] = useState({ no_of_new_patients_today: 0 });
  const currentDate = new Date();
  const navigate = useNavigate();

  async function getDashboardData() {
    try {
      const dateToday = new Date().toISOString().split("T")[0];
      const response = await fetchNewPatients([dateToday, dateToday]);
      // API returns { data: { data: count } } - extract the actual count value
      const count = response?.data?.data || response?.data || 0;
      setData(prev => ({ ...prev, no_of_new_patients_today: count }));
    } catch (error) {
      console.error("Error fetching new patients:", error);
    }
  }

  //get greetings by time of the day
  function getTimeOfDay() {
    const currentHour = new Date().getHours();
    if (currentHour >= 5 && currentHour < 12) {
      return "Morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "Afternoon";
    } else {
      return "Evening";
    }
  }

  // Handler for Register Patient button
  const handleRegisterPatient = () => {
    navigate("/philhealth/is-registered");
  };

  // Handler for Consult Patient button
  const handleConsultPatient = () => {
    navigate("/consult/select-patient");
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay());
    }, 60000); // Update every minute to reflect the current time of day

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App dashboard">
      <SidebarMenu active={"Dashboard"} />
      <div className=" ml-2 mt-3 col outer-dashboard">
        <Row className="ps-4 mb-4 greeting-dashboard">
          <Col xs={10} className="user-info">
            <Row className="font-big title-2">
              Good {timeOfDay},{" "}
              {(role === "director" || role === "pcp" || role === "specialist") ? "" : "nurse"}{" "}
              {getName()}👋!
            </Row>
            <Row className="accreditation-number">
              <small>CPCI - Accreditation No: P07038715</small>
            </Row>
          </Col>
          <Col>
            <Row className="pt-3">
              <h6 id="normal-text account-owner">
                {formatDateWithTime(currentDate)}
              </h6>
            </Row>
          </Col>
        </Row>
        <Row className="dashboard-main">
          <Col xs={12} className="left-pane p-3">
            <div className="left-actions">
              <div className="left-top">
                <div className="card yakap-card-card new-patients-card">
                  <div className="yakap-card-header">
                    <p className="yakap-subtitle">New Patients</p>
                  </div>
                  <div className="yakap-card-body">
                    <p className="new-patient-count">{data.no_of_new_patients_today || 0}</p>
                  </div>
                </div>
              </div>
              <div className="left-buttons-wrap">
              <div className="left-buttons">
                <button
                  className="action-lg-btn register-btn"
                  onClick={handleRegisterPatient}
                >
                  Register Patient
                </button>
                <button
                  className="action-lg-btn consult-btn"
                  onClick={handleConsultPatient}
                >
                  Consult Patient
                </button>
              </div>
              </div>
              <div className="yakap-logo-cont">
                <img src={YakapLogo} alt="Yakap logo" className="yakap-logo" />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Dashboard;
